import Flickity from 'flickity';

import 'flickity/dist/flickity.min.css';
import 'flickity-fade/flickity-fade.css';

// Make available globally
window.Flickity = Flickity;
